import { Account } from '@models/account/account.model';

import { ApiAdapter } from './adapter';
import { LegalEntityAdapter } from './legal-entity.adapter';
import { SiteAdapter } from './site.adapter';

export class AccountAdapter extends ApiAdapter<Account> {
  private siteAdapter = new SiteAdapter();
  private legalEntityAdapter = new LegalEntityAdapter();
  private featureLabel = 'FEATURE_';

  get(json): Account {
    const extractionHiddenPages = json['hidden_pages'] ? this.extractHiddenPages(json['hidden_pages']) : [];
    return new Account({
      id: json['id'],
      name: json['name'],
      panEuropean: json['pan_european'],
      reseller: json['reseller'],
      legalEntities: this.legalEntityAdapter.list(json['legal_entities']),
      sites: this.siteAdapter.list(json['sites']),
      hiddenPages: extractionHiddenPages
        .filter((extraction) => !extraction.startsWith(this.featureLabel))
        .map((page) => page.toLowerCase()),
      features: extractionHiddenPages
        .filter((extraction) => extraction.startsWith(this.featureLabel))
        .map((feature: string) => {
          feature = feature.replace(this.featureLabel, '');
          return this.camelCase(feature);
        }),
      gemforceAccountId: json['gemforce_account_id'],
      visibleInFront: json['visible_in_ge_front'],
    });
  }

  private camelCase(value: string): string {
    return value
      .split('_')
      .map((it, index) => (index === 0 ? it.toLocaleLowerCase() : it[0].toUpperCase() + it.slice(1).toLocaleLowerCase()))
      .join('');
  }

  private extractHiddenPages(json: string[]): string[] {
    if (!json) {
      return [];
    }

    return json.filter((el) => {
      try {
        return !JSON.parse(el.replace(';', ','));
      } catch (_) {
        return true;
      }
    });
  }
}
